import type { AppLocale } from './localeConfig'

type LocaleModule = { default: Record<string, unknown> }

/** Dynamic imports keep initial bundle small — only English ships with the main chunk. */
export const localeLoaders: Record<AppLocale, () => Promise<LocaleModule>> = {
  en: () => import('@/locales/en.json'),
  zh: () => import('@/locales/zh.json'),
  hi: () => import('@/locales/hi.json'),
  es: () => import('@/locales/es.json'),
  ar: () => import('@/locales/ar.json'),
  fr: () => import('@/locales/fr.json'),
  pt: () => import('@/locales/pt.json'),
  ru: () => import('@/locales/ru.json'),
  ur: () => import('@/locales/ur.json'),
  id: () => import('@/locales/id.json'),
  de: () => import('@/locales/de.json'),
  ja: () => import('@/locales/ja.json'),
  sw: () => import('@/locales/sw.json'),
  tr: () => import('@/locales/tr.json'),
  vi: () => import('@/locales/vi.json'),
  ko: () => import('@/locales/ko.json'),
  it: () => import('@/locales/it.json'),
  th: () => import('@/locales/th.json'),
  pl: () => import('@/locales/pl.json'),
  uk: () => import('@/locales/uk.json'),
  ms: () => import('@/locales/ms.json'),
  he: () => import('@/locales/he.json'),
  nl: () => import('@/locales/nl.json'),
  ro: () => import('@/locales/ro.json'),
  hu: () => import('@/locales/hu.json'),
  el: () => import('@/locales/el.json'),
  cs: () => import('@/locales/cs.json'),
  sv: () => import('@/locales/sv.json'),
  fil: () => import('@/locales/fil.json'),
}
